if (!customElements.get("product-form")) {
  // Set to true to skip webhook and use only Shopify add-to-cart response for rendering
  const WEBHOOK_DISABLED = true;

  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.notification = document.getElementById("CartNotification");
        this.drawer = document.getElementById("CartDrawerComponent");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector("span");
        if (document.querySelector("cart-drawer"))
          this.submitButton?.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      } 


      async getCartJson() {
        const response = await fetch(`${routes.cart_url}.json`);
        const responseJSON = await response.json();
        return await responseJSON;
      }

      async pingWebhook() {
        try {
          console.log("pinging webhook...", new Date().toISOString());
          const cartJson = await this.getCartJson();
          
          // Remove unnecessary fields from each item to reduce payload size
          if (cartJson.items && Array.isArray(cartJson.items)) {
            cartJson.items = cartJson.items.map(item => {
              const cleanedItem = { ...item };
              delete cleanedItem.product_description;
              delete cleanedItem.image;
              delete cleanedItem.product_title;
              return cleanedItem;
            });
          }
          
          const customerId = window.wishlist?.id;
          cartJson.customer_id = customerId || null;

          const res = await fetch(
            "http://shopifywebhook.mrpet.si/api/cart/webhook",
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(cartJson),
            },
          );
          console.log("Webhook response raw:", res);
          //const data = await res.json();
          console.log("Webhook response:", res.status);
          // Return success status - check HTTP status and optionally API response success indicator

          //remove  !== after testing
          return res.ok && (res.status !== 200);
        } catch (error) {
          console.error("Cart webhook error", error);
          return false;
        }
      }

      async fetchFreshSections(sectionsToRender) {
        try {
          // Fetch sections - Shopify returns HTML with sections
          // We need to fetch each section individually to match the format from cart add API
          const sections = {};
          
          for (const section of sectionsToRender) {
            try {
              // Use section.section if available (Shopify section ID), otherwise use section.id
              const shopifySectionId = section.section || section.id;
              if (!shopifySectionId) {
                console.warn(`Skipping section - no shopifySectionId:`, section);
                continue;
              }

              const sectionsUrl = `${routes.cart_url}?section_id=${shopifySectionId}`;
              console.log(`Fetching fresh section: ${shopifySectionId} (id: ${section.id}) from ${sectionsUrl}`);
             // const response = await fetch(sectionsUrl);
              const html = await response.text();
              const parsedHtml = new DOMParser().parseFromString(html, "text/html");
              
              // Debug: log what we got
              console.log(`HTML response for ${shopifySectionId}:`, html.substring(0, 500));
              
              // Shopify returns sections as <div id="shopify-section-{id}" class="shopify-section">
              // Try finding the div with shopify-section- prefix first
              let sectionElement = parsedHtml.querySelector(`#shopify-section-${shopifySectionId}`);
              
              // Also try finding by section[data-section-id] (for actual section elements)
              if (!sectionElement) {
                sectionElement = parsedHtml.querySelector(`section[data-section-id="${shopifySectionId}"]`);
              }
              
              // Try finding div with class shopify-section and matching id pattern
              if (!sectionElement) {
                sectionElement = parsedHtml.querySelector(`div.shopify-section[id*="${shopifySectionId}"]`);
              }
              
              // Try finding by ID attribute directly
              if (!sectionElement && section.id) {
                sectionElement = parsedHtml.querySelector(`#${section.id}`);
              }
              
              // Try finding any element with shopify-section class (fallback)
              if (!sectionElement) {
                const shopifySections = parsedHtml.querySelectorAll('.shopify-section');
                console.log(`Found ${shopifySections.length} .shopify-section elements in HTML`);
                // Look for element that matches our section ID
                for (const sec of shopifySections) {
                  if (sec.id && (sec.id.includes(section.id) || sec.id.includes(shopifySectionId))) {
                    sectionElement = sec;
                    break;
                  }
                }
              }
              
              // If still not found, check if body itself is the section wrapper
              if (!sectionElement) {
                const bodyContent = parsedHtml.body;
                if (bodyContent) {
                  // Check if body has a direct child with shopify-section class
                  const directChild = bodyContent.firstElementChild;
                  if (directChild && directChild.classList.contains('shopify-section')) {
                    sectionElement = directChild;
                  }
                }
              }
              
              if (sectionElement) {
                // Store with section.id as key (what renderContents expects)
                // Store the outerHTML to match Shopify's cart add API response format
                // This includes the wrapper div with class "shopify-section"
                const sectionHtml = sectionElement.outerHTML;
                
                // Verify the HTML can be parsed and selector works (for debugging)
                try {
                  const testParser = new DOMParser().parseFromString(sectionHtml, 'text/html');
                  const testSelector = section.selector || '.shopify-section';
                  const testElement = testParser.querySelector(testSelector);
                  if (testElement) {
                    console.log(`✓ Successfully fetched and stored section: ${section.id} (selector works)`);
                  } else {
                    console.warn(`⚠ Section ${section.id} stored but selector "${testSelector}" not found in HTML`);
                  }
                } catch (e) {
                  console.warn(`⚠ Error testing section ${section.id}:`, e);
                }
                
                sections[section.id] = sectionHtml;
                console.log(`Section HTML preview:`, sectionHtml.substring(0, 200));
              } else {
                console.warn(`✗ Could not find section element for ${shopifySectionId} (id: ${section.id})`);
                console.warn(`HTML structure:`, parsedHtml.body?.innerHTML?.substring(0, 200));
              }
            } catch (sectionError) {
              console.error(`Failed to fetch section ${section.section || section.id}:`, sectionError);
            }
          }
          
          console.log(`Fetched ${Object.keys(sections).length} fresh sections:`, Object.keys(sections));
          return Object.keys(sections).length > 0 ? sections : null;
        } catch (error) {
          console.error("Failed to fetch fresh sections", error);
          return null;
        }
      }

      async buildRenderState(baseResponse) {
        if (WEBHOOK_DISABLED) {
          return baseResponse;
        }
        console.log("buildRenderState - baseResponse sections keys:", baseResponse.sections ? Object.keys(baseResponse.sections) : 'no sections');
        
        // First ping webhook and wait for it to complete
        const webhookSuccess = await this.pingWebhook();
        console.log("Webhook success:", webhookSuccess);
        
        // Small delay to ensure cart is fully updated after webhook
        if (webhookSuccess) {
          await new Promise(resolve => setTimeout(resolve, 100));
        }
        
        // After webhook success, fetch fresh cart and sections for rendering
        let cartState = baseResponse;
        let sectionsToUse = { ...(baseResponse.sections || {}) }; // Start with base sections
        
        if (webhookSuccess) {
          try {
            // Always fetch fresh cart JSON after webhook success
            cartState = await this.getCartJson();
            console.log("Fresh cart state - item_count:", cartState.item_count);
            
            // Always fetch fresh sections after webhook success
            // Focus on cart drawer sections (most important) and cart-icon-bubble
            const drawerSections = this.drawer?.getSectionsToRender() || [];
            // Also fetch cart-icon-bubble for cart count updates
            const iconBubbleSection = { id: 'cart-icon-bubble', section: 'cart-icon-bubble' };
            const allSections = [...drawerSections, iconBubbleSection];
            
            console.log("Sections to fetch (drawer focus):", allSections.map(s => ({ id: s.id, section: s.section })));
            
            const freshSections = await this.fetchFreshSections(allSections);
            if (freshSections) {
              // Merge fresh sections with base sections (fresh takes priority)
              // This ensures cart drawer gets fresh content
              sectionsToUse = { ...sectionsToUse, ...freshSections };
              console.log("Using fresh sections after webhook success");
              console.log("Fresh sections keys:", Object.keys(freshSections));
              console.log("Final sections keys:", Object.keys(sectionsToUse));
            } else {
              console.warn("Failed to fetch fresh sections, using response sections");
            }
          } catch (freshCartError) {
            console.error("Failed to fetch fresh cart json or sections", freshCartError);
            // Fallback to base response if fresh fetch fails
            cartState = baseResponse;
          }
        } else {
          console.warn("Webhook did not succeed, using response data for rendering");
        }
        
        console.log("Final cart state - item_count:", cartState.item_count);
        
        // Return fresh cart state with fresh sections, preserving other baseResponse properties
        const finalState = {
          ...baseResponse,
          ...cartState,  // Fresh cart state overwrites base response cart data
          sections: sectionsToUse  // Fresh sections merged with base sections
        };
        console.log("Final render state - sections keys:", Object.keys(finalState.sections));
        return finalState;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("atc-loading");
        // this.querySelector('.loading__spinner').classList.remove('hidden');

        // Disable all other add-to-cart buttons while this one is processing
        this.disabledButtons = this.disableOtherAddToCartButtons();

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.notification || this.drawer) {
          formData.append("sections", [
            ...(this.notification
              ? this.notification.getSectionsToRender().map((section) => section.id)
              : []),
            ...(this.drawer
              ? this.drawer.getSectionsToRender().map((section) => section.id)
              : []),
          ]);
          formData.append("sections_url", window.location.pathname);
          if (this.notification) this.notification.setActiveElement(document.activeElement);
          if (this.drawer) this.drawer.setActiveElement?.(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (response) => { 
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.setAttribute("data-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.notification && !this.drawer) {
              window.location = window.routes.cart_url;
              return;
            }
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              const renderState = await this.buildRenderState(response);
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    if (this.drawer) {
                      this.drawer.renderContents(renderState, true);
                    } else if (this.notification) {
                      this.notification.renderContents(renderState);
                    }
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else {
              const renderState = await this.buildRenderState(response);
              if (this.drawer) {
                this.drawer.renderContents(renderState, true);
              } else if (this.notification) {
                this.notification.renderContents(renderState);
              }
            }
          })
          .catch((e) => { 
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.drawer && this.drawer.classList.contains("is-empty"))
              this.drawer.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.submitButton.classList.remove("atc-loading");
            // Drop sticky :hover on touch so the outlined card button resets
            // after loading (CSS also gates hover to fine pointers).
            this.submitButton.blur();
            // this.querySelector('.loading__spinner').classList.add('hidden');
            
            // Re-enable all other add-to-cart buttons
            this.enableOtherAddToCartButtons();
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }

      disableOtherAddToCartButtons() {
        // Find the closest variants-gallery component that contains this product-form
        const variantsGallery = this.closest("variants-gallery");
        
        // If no variants-gallery found, don't disable anything (fallback behavior)
        if (!variantsGallery) return [];

        const disabledButtons = [];

        // Find all product-form elements within the same variants-gallery
        const productFormsInGallery = variantsGallery.querySelectorAll("product-form");

        productFormsInGallery.forEach((productForm) => {
          // Skip the current product-form
          if (productForm === this) return;

          // Find the submit button in this product-form
          const submitButton = productForm.querySelector('button.add-to-cart[type="submit"]');
          
          if (submitButton) {
            // Only disable if button is not already disabled
            if (submitButton.getAttribute("aria-disabled") !== "true" && 
                !submitButton.hasAttribute("disabled")) {
              submitButton.classList.add("pointer-events-none", "cursor-not-allowed");
              disabledButtons.push(submitButton);
            }
          }
        });

        return disabledButtons;
      }

      enableOtherAddToCartButtons() {
        // Re-enable all buttons that were disabled
        if (this.disabledButtons && Array.isArray(this.disabledButtons)) {
          this.disabledButtons.forEach((button) => {
            button.classList.remove("pointer-events-none", "cursor-not-allowed");
          });
          this.disabledButtons = [];
        }
      }
    },
  );
}